import React, { useMemo, memo } from 'react';
import { Button } from "devextreme-react/button";
import ReactMarkdown from 'react-markdown';
import { saveAs } from 'file-saver';
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkDocx from 'remark-docx';
import showdown from 'showdown';
import notify from 'devextreme/ui/notify';

import './AXPCAssistant.scss';

const AXPCAssistantMessage = memo(({ messageData, isFirstMessage, suggestions, onSuggestionClick }) => {
  const isAssistant = messageData.author.id === 'assistant';

  const handleCopyClick = () => {
    const converter = new showdown.Converter({
      tables: true,
      simplifiedAutoLink: true,
      strikethrough: true,
      tasklists: true,
      ghCodeBlocks: true
    });
    const html = converter.makeHtml(messageData.text);

    if (navigator.clipboard && window.ClipboardItem) {
      const textBlob = new Blob([messageData.text], { type: 'text/plain' });
      const htmlBlob = new Blob([html], { type: 'text/html' });
      const data = new ClipboardItem({
        'text/plain': textBlob,
        'text/html': htmlBlob
      });

      navigator.clipboard.write([data])
        .then(() => {
          notify('Text copied to clipboard with formatting', 'success', 2000);
        })
        .catch(err => {
          console.error('Failed to copy formatted text: ', err);
          // Fallback to plain text
          navigator.clipboard.writeText(messageData.text)
            .then(() => {
              notify('Text copied to clipboard (plain text)', 'success', 2000);
            })
            .catch(fallbackErr => {
              console.error('Fallback copy failed: ', fallbackErr);
            });
        });
    } else {
      // Fallback for browsers that don't support ClipboardItem
      navigator.clipboard.writeText(messageData.text)
        .then(() => {
          notify('Text copied to clipboard (plain text)', 'success', 2000);
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
        });
    }
  };

  const handleDownloadClick = async () => {
    const processor = unified().use(remarkParse).use(remarkDocx);
    const file = await processor.process(messageData.text);
    const arrayBuffer = await file.result;
    const blob = new Blob([arrayBuffer]);
    saveAs(blob, 'assistant-message.docx');
  };

  return (
    <div className={`dx-item dx-chat-message ${!isAssistant ? 'user-message-container' : ''}`}>
      <div className={`dx-chat-message-content ${!isAssistant ? 'user-message' : ''}`}>
        <ReactMarkdown>{messageData.text}</ReactMarkdown>
        {isAssistant && isFirstMessage && (
          <div className="d-flex flex-wrap gap-2 mt-3">
            {suggestions.map((suggestion, index) => (
              <div
                key={index}
                onClick={() => onSuggestionClick(suggestion)}
                className="suggestion-pill"
              >{suggestion}</div>
            ))}
          </div>
        )}
        {isAssistant && !isFirstMessage && messageData.text && (
          <div className="copy-button-container">
            <Button icon="far fa-copy" stylingMode="text" onClick={handleCopyClick} /><Button icon="far fa-file-word" stylingMode="text" onClick={handleDownloadClick} />
          </div>
        )}
      </div>
    </div>
  );
});

export default AXPCAssistantMessage;